"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFdrOpenMethod = void 0;
const supergraph_api_1 = require("@hotelplan/supergraph-api");
const getFdrOpenMethod = (openMethod) => {
    switch (openMethod) {
        case supergraph_api_1.FdrLinkOpenMethod.NewTab:
        case supergraph_api_1.FdrLinkOpenMethod.NewWindow:
            return `_blank`;
        case supergraph_api_1.FdrLinkOpenMethod.Overlay:
            return supergraph_api_1.FdrLinkOpenMethod.Overlay;
        case supergraph_api_1.FdrLinkOpenMethod.ThisTab:
            return `_self`;
        default:
            return undefined;
    }
};
exports.getFdrOpenMethod = getFdrOpenMethod;
//# sourceMappingURL=open-method.js.map